var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuessTheAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.4 175C58.9775 175 25.4001 141.423 25.4001 100C25.4001 58.5774 58.9775 25 100.4 25C141.823 25 175.4 58.5774 175.4 100C175.4 141.423 141.823 175 100.4 175Z",
    fill: "url(#paint0_linear_26801_1691)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.328 127.89H160.589C165.219 127.89 168.995 131.667 168.995 136.296V166.605C168.995 167.155 168.694 167.626 168.194 167.856C167.695 168.086 167.141 168.009 166.723 167.651L156.644 159.03H72.328C67.6985 159.03 63.9221 155.254 63.9221 150.625V136.296C63.9221 131.666 67.6982 127.89 72.328 127.89Z",
    fill: "url(#paint1_linear_26801_1691)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.558 136.296V164.088L166.723 167.651C167.141 168.009 167.694 168.086 168.194 167.855C168.694 167.625 168.995 167.155 168.995 166.605V136.296C168.995 131.667 165.219 127.89 160.589 127.89H154.152C158.781 127.89 162.558 131.667 162.558 136.296Z",
    fill: "url(#paint2_linear_26801_1691)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6941 145.663C82.4773 145.663 81.491 144.677 81.491 143.46C81.491 142.243 82.4773 141.257 83.6941 141.257H113.3C114.516 141.257 115.503 142.243 115.503 143.46C115.503 144.677 114.516 145.663 113.3 145.663H83.6941ZM127.867 145.663C126.65 145.663 125.664 144.677 125.664 143.46C125.664 142.243 126.65 141.257 127.867 141.257H149.223C150.44 141.257 151.426 142.243 151.426 143.46C151.426 144.677 150.439 145.663 149.223 145.663H127.867Z",
    fill: "#F9F6F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.589 32H40.8058C36.1765 32 32.4001 36.1219 32.4001 41.1747V139.494C32.4001 140.148 32.7648 140.705 33.3323 140.916C33.8998 141.127 34.5 140.931 34.8666 140.413L48.8051 120.724H160.589C165.218 120.724 168.995 116.602 168.995 111.549V41.1747C168.995 36.1216 165.218 32 160.589 32Z",
    fill: "url(#paint3_linear_26801_1691)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.075 41.1747V111.549C162.075 116.602 158.299 120.724 153.669 120.724H160.589C165.218 120.724 168.995 116.602 168.995 111.549V41.1747C168.995 36.1213 165.218 32 160.589 32H153.669C158.299 32 162.075 36.1216 162.075 41.1747ZM48.8051 120.724H41.8855L32.4001 134.123V139.494C32.4001 140.148 32.7648 140.705 33.3323 140.916C33.8998 141.128 34.5 140.931 34.8666 140.413L48.8051 120.724Z",
    fill: "url(#paint4_linear_26801_1691)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.976 69.3264L81.9363 106.237H150.868C151.438 106.237 151.925 105.881 152.142 105.304C152.358 104.728 152.24 104.1 151.833 103.663L119.848 69.3162C118.774 68.1637 117.044 68.168 115.976 69.3264Z",
    fill: "#F9F6F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.811 106.237L105.297 80.9061L94.5203 92.5921L119.811 106.237Z",
    fill: "#DDDAEC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.697 85.7126L85.4188 69.3061C84.3487 68.1571 82.6263 68.1571 81.5562 69.3061L49.5613 103.663C49.1545 104.1 49.0366 104.728 49.2527 105.304C49.469 105.881 49.9562 106.237 50.5268 106.237H119.811L100.697 85.7126Z",
    fill: "#F9F6F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.697 62.457C104.781 62.457 108.092 58.8434 108.092 54.3859C108.092 49.9284 104.781 46.3149 100.697 46.3149C96.6134 46.3149 93.3027 49.9284 93.3027 54.3859C93.3027 58.8434 96.6134 62.457 100.697 62.457Z",
    fill: "#F9F6F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1691",
    x1: 25.4001,
    y1: 36.7188,
    x2: 168.369,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1691",
    x1: 75.4145,
    y1: 127.89,
    x2: 121.408,
    y2: 203.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1691",
    x1: 155.775,
    y1: 127.89,
    x2: 178.405,
    y2: 133.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1691",
    x1: 100.697,
    y1: 32,
    x2: 100.697,
    y2: 141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_1691",
    x1: 100.697,
    y1: 32,
    x2: 100.697,
    y2: 141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuessTheAnswer);
export default __webpack_public_path__ + "static/media/Guess-the-Answer.eadbd5d2c7737e3a3dd6256989ac3b86.svg";
export { ForwardRef as ReactComponent };